// Abbreviate large y-axis tick labels app-wide: 1000 → 1k, 1_500_000 → 1.5m,
// 2_000_000_000 → 2b. Chartkick serializes each chart's `library:` options to JSON,
// so a Chart.js tick callback can't be passed from the Ruby side. But chartkick only
// installs its own y-axis callback when none is set (`if (!axis.ticks.callback)`) and
// deep-merges the global defaults registered here via setDefaultOptions, so this
// callback wins. Time (x) axes are untouched — they don't use a numeric callback.
import Chartkick from "chartkick"

function abbreviate(value) {
  const n = Number(value)
  if (!isFinite(n)) return value
  if (n === 0) return "0"

  const abs = Math.abs(n)
  const [divisor, suffix] =
    abs >= 1e9 ? [1e9, "b"] :
    abs >= 1e6 ? [1e6, "m"] :
    abs >= 1e3 ? [1e3, "k"] :
    [1, ""]

  // One decimal, trailing ".0" dropped: 1.0k → 1k, 1.5k stays 1.5k.
  const scaled = parseFloat((n / divisor).toFixed(1))
  return `${scaled}${suffix}`
}

Chartkick.setDefaultOptions({
  library: { scales: { y: { ticks: { callback: abbreviate } } } }
})

export { abbreviate }
